import React from 'react';

import { connect } from 'react-redux';

import Start from '../templates/template.start';
import DefaultPage from '../templates/template.default';
import SignupPage from '../templates/template.signup';
import SignupModel from '../templates/template.signup-model';
import EventsPage from '../templates/template.events';
import EventForm from '../templates/template.event-form';
import ModelsPage from '../templates/template.models';
import ModelsSingle from '../templates/template.models-single';
import ContractsPage from '../templates/template.contracts';
import ContractSingle from '../templates/template.contract-single';
import LoginPage from '../templates/template.login';
import ProfilePage from '../templates/template.profile';
import ContractExport from '../templates/template.contract-export'

import { Redirect } from 'react-router-dom';

const Page = (props) => {

    if (!props.pageState.page) {
        return <div className="loader"></div>;
    }

    if (!props.authState.token && props.pageState.page.template !== 'login') {
        return <Redirect to="/login" />
    } else if (props.authState.token && props.authState.user && props.pageState.page.template === 'login') {
        return <Redirect to="/" />
    }

    let template = null;
    switch (props.pageState.page.template) {
        case 'start':
            template = <Start {...props.page} />
            break;
        case 'login':
            template = <LoginPage {...props.page} />
            break;
        case 'signup':
            template = <SignupPage {...props.page} />
            break;
        case 'signup-model':
            template = <SignupModel {...props.page} />
            break;
        case 'profile':
            template = <ProfilePage {...props.page} />
            break;
        case 'events':
            template = <EventsPage {...props.page} />
            break;
        case 'event-form':
            template = <EventForm {...props.page} />
            break;
        case 'models':
            template = <ModelsPage {...props.page} />
            break;
        case 'models-single':
            template = <ModelsSingle {...props.page} />
            break;
        case 'contracts':
            template = <ContractsPage {...props.page} />
            break;
        case 'contract-single':
            template = <ContractSingle {...props.page} />
            break;
        case 'contracts-export':
            template = <ContractExport {...props.page} />
            break;
        default:
            template = <DefaultPage {...props.page} />
            break;
    }

    return template;
}

export default connect(store => (store) => {
    return {
        pageState: store.pageState,
        authState: store.authState
    }
})(Page);
